<template>
  <div v-if="currentReport" class="edit-form">
    <h4>Comunicação de perdas ocorrida</h4>
    <form>

      <div class="form-group">
        <label for="name_farmer">Nome do produtor rural</label>
        <input type="text" class="form-control" id="name_farmer"
          v-model="currentReport.name_farmer"
        />
      </div>

      <div class="form-group">
        <label for="email_farmer">E-mail do produtor rural</label>
        <input type="email" class="form-control" id="email_farmer"
          v-model="currentReport.email_farmer"
        />
      </div>

      <div class="form-group">
        <label for="cpf_farmer">CPF do produtor rural</label>
        <input type="email" pattern="\d{3}\.?\d{3}\.?\d{3}-?\d{2}" class="form-control" id="cpf_farmer"
          v-model="currentReport.cpf_farmer"
        />
      </div>

      <div class="form-group">
      <label for="loc_titllage_lat">Latitude</label>
        <input type="text" class="form-control" id="loc_titllage_lat"
          v-model="currentReport.loc_titllage_lat"
        />
      </div>

      <div class="form-group">
      <label for="loc_tittlage_lon">Longitude</label>
        <input type="text" class="form-control" id="loc_tittlage_lon"
          v-model="currentReport.loc_tittlage_lon"
        />
      </div>

      <div class="form-group">
      <label for="event_date">Lavoura</label>
      <br />
        <select id="type_tillage" class="form_control" v-model="currentReport.type_tillage">
          <option value="" disabled selected>Selecione</option>
          <option value="MI">MILHO</option>
          <option value="SO">SOJA</option>
          <option value="TR">TRIGO</option>
          <option value="FE">FEIJÃO</option>
        </select>
      </div>

      <div class="form-group">
      <label for="harvest_date">Data da colheita</label>
        <input type="date" class="form-control" id="harvest_date"
          v-model="currentReport.harvest_date"
        />
      </div>

      <div class="form-group">
      <label for="event_date">Data do evento</label>
        <input type="date" class="form-control" id="event_date"
          v-model="currentReport.event_date"
        />
      </div>

      <div class="form-group">
      <label for="event_date">Ocorrência</label>
      <br />
        <select id="event" class="form_control" v-model="currentReport.event">
          <option value="" disabled selected>Selecione</option>
          <option value="CE">CHUVA EXCESSIVA</option>
          <option value="GE">GEADA</option>
          <option value="GR">GRANIZO</option>
          <option value="SE">SECA</option>
          <option value="VE">VENDAVAL</option>
          <option value="RA">RAIO</option>
        </select>
      </div>

    </form>
    <div>
      <span class="badge badge-info">{{ message }}</span>
    </div>

<div class="btn-group" role="group" aria-label="Basic example">
    <router-link to="/reports" class="badge badge-info">Voltar</router-link>

    <button type="submit" class="badge badge-success"
      @click="updateReport"
    >
      Alterar
    </button>

    <button class="badge badge-danger"
      @click="deleteReport"
    >
      Deletar
    </button>
</div>
    <p></p>
    <p></p>
    <br />
    
  </div>

  <div v-else>
    <br />
    <p>Por favor clique na COP...</p>
  </div>
</template>

<script>
import ReportDataService from "../services/ReportDataService";

export default {
  name: "report",
  data() {
    return {
      currentReport: null,
      message: ''
    };
  },
  methods: {
    getReport(id) {
      ReportDataService.get(id)
        .then(response => {
          this.currentReport = response.data;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updateReport() {
      ReportDataService.update(this.currentReport.id, this.currentReport)
        .then(response => {
          console.log(response.data);
          this.message = response.data.info;
        })
        .catch(e => {
          console.log(e);
          console.log(this.currentReport);
        });
    },

    deleteReport() {
      ReportDataService.delete(this.currentReport.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "reports" });
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  mounted() {
    this.message = '';
    this.getReport(this.$route.params.id);
  }
};


</script>

<style>
.edit-form {
  max-width: 500px;
  margin: auto;
}
</style>
